import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['declaration', 'statement', 'submitButton'];

  connect() {
    this.update();
  }

  update() {
    const selected = this.element.querySelector('input[name="calculation_for[selected_option_id]"]:checked');
    this.declarationTarget.hidden = !selected;
    this.statementTargets.forEach((statement) => {
      statement.hidden = !selected || statement.dataset.calculationFor !== selected.value;
    });
    this.submitButtonTarget.disabled = !selected;
  }
}
